var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"group-component",class:{
        collapsed: !_vm.show,
    }},[_c('div',{staticClass:"group-headline",on:{"click":_vm.toggle}},[_c('SvgIcon',{attrs:{"name":"toggle"}}),_c('h1',[_vm._v(_vm._s(_vm.title))])],1),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}]},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }